var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.998 17.7684C21.998 18.5017 21.6863 19.2026 21.1363 19.7061L4.63679 34.8095C3.53265 35.8202 1.7922 35.772 0.749409 34.7019C-0.293406 33.6317 -0.243675 31.9448 0.860462 30.9341L15.2431 17.7684L0.860462 4.60272C-0.243675 3.59212 -0.293406 1.90521 0.749409 0.835087C1.7922 -0.235252 3.53265 -0.283451 4.63679 0.727364L21.1363 15.8307C21.6863 16.3342 21.998 17.0351 21.998 17.7684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.53e2d728f909e2438d392ef122fc8899.svg";
export { ForwardRef as ReactComponent };